import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { INotificationIdentitySubscribed } from "@/types/feed.types";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { getTimeAgoShort } from "@/helpers/Helpers";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
export default function NotificationIdentitySubscribed(t0) {
  const $ = _c(24);
  const {
    notification
  } = t0;
  let t1;
  if ($[0] !== notification.related_identity.pfp) {
    t1 = <div className="tw-h-7 tw-w-7 tw-flex-shrink-0">{notification.related_identity.pfp ? <img src={getScaledImageUri(notification.related_identity.pfp, ImageScale.W_AUTO_H_50)} alt="#" className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" /> : <div className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" />}</div>;
    $[0] = notification.related_identity.pfp;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = notification.related_identity.handle ?? "";
  const t3 = `/${notification.related_identity.handle}`;
  let t4;
  if ($[2] !== notification.related_identity.handle || $[3] !== t3) {
    t4 = <Link href={t3} className="tw-no-underline tw-font-semibold">{notification.related_identity.handle}</Link>;
    $[2] = notification.related_identity.handle;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <span className="tw-text-sm tw-font-normal tw-text-iron-400"><UserProfileTooltipWrapper user={t2}>{t4}</UserProfileTooltipWrapper>{" "}started following you</span>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-font-bold tw-mr-1 tw-text-xs tw-text-iron-400">•</span>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== notification.created_at) {
    t7 = getTimeAgoShort(notification.created_at);
    $[9] = notification.created_at;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t6}{" "}{t7}</span>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t8) {
    t9 = <span className="tw-inline tw-flex-wrap tw-items-center">{t5}{" "}{t8}</span>;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== notification.related_identity) {
    t10 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
    $[16] = notification.related_identity;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <div className="tw-flex tw-flex-1 tw-justify-between tw-gap-x-3 tw-gap-y-1">{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t1 || $[22] !== t11) {
    t12 = <div className="tw-w-full tw-flex tw-items-start md:tw-items-center tw-gap-x-3 tw-flex-wrap">{t1}{t11}</div>;
    $[21] = t1;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}